import React from 'react'

// Magnifier-minus glyph from the DS (Figma 326:2932). Sizes with 1em, inherits currentColor.
const RING_D = 'M8.00492 0C6.4217 0 4.87403 0.46948 3.55763 1.34907C2.24122 2.22866 1.21521 3.47886 '
  + '0.609342 4.94157C0.00346838 6.40428 -0.155056 8.0138 0.153816 9.5666C0.462687 11.1194 1.22508 '
  + '12.5457 2.34459 13.6653C3.4641 14.7848 4.89044 15.5472 6.44324 15.856C7.99604 16.1649 9.60556 '
  + '16.0064 11.0683 15.4005C12.531 14.7946 13.7812 13.7686 14.6608 12.4522C15.5404 11.1358 16.0098 '
  + '9.58814 16.0098 8.00492C16.0075 5.88261 15.1633 3.84792 13.6626 2.34722C12.1619 0.846522 '
  + '10.1272 0.00238357 8.00492 0ZM8.00492 14.0086C6.8175 14.0086 5.65675 13.6565 4.66945 '
  + '12.9968C3.68215 12.3371 2.91264 11.3995 2.45824 10.3024C2.00383 9.2054 1.88494 7.99826 2.11659 '
  + '6.83366C2.34825 5.66906 2.92004 4.5993 3.75967 3.75967C4.5993 2.92004 5.66906 2.34824 6.83366 '
  + '2.11659C7.99826 1.88494 9.2054 2.00383 10.3024 2.45823C11.3995 2.91264 12.3371 3.68215 12.9968 '
  + '4.66945C13.6565 5.65675 14.0086 6.8175 14.0086 8.00492C14.007 9.59671 13.374 11.1228 12.2484 '
  + '12.2484C11.1228 13.374 9.59671 14.007 8.00492 14.0086Z'
const HANDLE_D = 'M19.7191 18.3042L15.7167 14.3018C15.5279 14.1195 15.2752 14.0187 15.0128 '
  + '14.0209C14.7505 14.0232 14.4995 14.1285 14.314 14.314C14.1285 14.4995 14.0232 14.7505 14.0209 '
  + '15.0128C14.0187 15.2752 14.1195 15.5279 14.3018 15.7167L18.3042 19.7191C18.493 19.9014 18.7457 '
  + '20.0022 19.0081 20C19.2704 19.9977 19.5214 19.8924 19.7069 19.7069C19.8924 19.5214 19.9977 '
  + '19.2704 20 19.0081C20.0022 18.7457 19.9014 18.493 19.7191 18.3042Z'
const MINUS_D = 'M11.0068 7.0043H5.00308C4.7377 7.0043 4.48319 7.10973 4.29554 7.29738C4.10788 '
  + '7.48503 4.00246 7.73954 4.00246 8.00492C4.00246 8.2703 4.10788 8.52481 4.29554 8.71246C4.48319 '
  + '8.90011 4.7377 9.00553 5.00308 9.00553H11.0068C11.2721 9.00553 11.5267 8.90011 11.7143 '
  + '8.71246C11.902 8.52481 12.0074 8.2703 12.0074 8.00492C12.0074 7.73954 11.902 7.48503 11.7143 '
  + '7.29738C11.5267 7.10973 11.2721 7.0043 11.0068 7.0043Z'

const ZoomOutIcon = () => (
  <svg fill="none" height="1em" viewBox="0 0 20 20" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d={RING_D} fill="currentColor" />
    <path d={HANDLE_D} fill="currentColor" />
    <path d={MINUS_D} fill="currentColor" />
  </svg>
)

export default ZoomOutIcon
